module.exports = __webpack_public_path__ + "img/eyes.8cf05a48.png";